<template>
<div ref="skipLink" tabindex="-1" :class="templateClass">
    <main-header></main-header>
    <div class="residentportal-default">
        <div class="container">
            <router-view class="residentportal-form"></router-view>
        </div>
    </div>
    <main-footer></main-footer>
</div>
</template>

<script>
    import Texts from '../common/utils/Texts'
    import MainHeader from '../common/components/Header';
    import MainFooter from '../common/components/Footer';
    import AccessibilityManager from '../common/utils/AccessibilityManager'
    import Helper from "../helper";
    export default {
        beforeCreate(){
            // Initialize Text Rendering Settings
            Texts.setModifiers({
                sentenceCase : true
            })
        },
        components: {
            MainHeader,
            MainFooter,
        },
        methods: {
            mainSiteLink: function(){
                location.href = this.$store.getters.GET_LANDING_PAGE_CONTENT.login_button_link;
            },
        },
        mounted() {
            this.$store.dispatch('getSiteWordingsSettings');
            new AccessibilityManager()
        },
        computed : {
            websiteTitle(){
                return this.$store.getters.GET_WEBSITE_METADATA.title
            },
            templateClass(){
                return {
                    'base-template': true,
                    [Helper.getPortalName()]: true
                };
            }
        },
        watch: {
            '$route':{
                handler(to, from){
                    if(!this.websiteTitle){
                        this.$store.dispatch('setWebsiteMetadata', { title : 'unset'})
                    }

                    // Setup Document Title
                    if(this.websiteTitle == "unset"){
                        this.$store.dispatch('setWebsiteMetadata', { title : document.title})
                    }

                    // Apply Document Title if it exists
                    if( this.websiteTitle != "unset"){
                        if(to.meta.title && this.websiteTitle){
                            document.title = to.meta.title + " - " + this.websiteTitle
                        }else{
                            document.title = this.websiteTitle
                        }
                    }
                    
                },
                immediate: true
            },
            //Skiplink focus when route url changes
            $route() {
              this.$refs.skipLink.focus();
            }
        },
    }
</script>
